module.exports = __webpack_public_path__ + "static/media/29EUNOG1.46e3fd59.jpg";